var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{staticClass:"mb-8",attrs:{"title":"Balance Remaining to Purchase","no_border":true}},[_c('input-money',{attrs:{"name":"balance_after_earnest_money","value":_vm.value,"read_only":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }